import NewMsgButton from './NewMsgButton';

export default NewMsgButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/NewMsgButton/index.js